var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jurisdiction-wrap"},[_c('div',{staticClass:"head-wrap"},[_c('img',{staticClass:"user-avatar",attrs:{"src":"https://qkodo.playlistmusic.com.cn/default%2Fdefault-avatr-2022061011.png"}}),_c('p',{staticClass:"name"},[_vm._v(_vm._s(_vm.userInfo.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }